import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Terminal Management System';

  ngOnInit(): void {
  }
}
